import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { constructDate } from '../../../../shared/components/DatePicker/formatDate/constructDate'
import { DatePickerPage } from '../../../../shared/pages/DatePickerPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { DatePickerInputRef } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { getDatePickerValidationErrorMessage } from '../../../../shared/utils/getDatePickerValidationErrorMessage/getDatePickerValidationErrorMessage'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { FlightDateFlow, WhichAirlineFlow } from '../../pageFlowData'
import { data } from './data'

export const FlightDate: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    flight: { date },
  } = state

  const FlightDateInput = useRef<DatePickerInputRef>(null)
  const [datePickerError, setDatePickerError] = useState('')

  /* v8 ignore next */
  const getValue = () => {
    return cleanText(FlightDateInput?.current?.datePickerInput?.value || date)
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${FlightDateFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    handleInputChange(value)
    dispatch({ type: 'UPDATE_STEP', data: WhichAirlineFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: WhichAirlineFlow.PROGRESS_VALUE })
  }

  /* v8 ignore next */
  const handleInputChange = (value: string) => {
    dispatch({ type: 'UPDATE_FLIGHT_DATE', data: value })
  }

  const handleSubmit = () => {
    setDatePickerError('')
    const dateInputValue: string = getValue()
    const errorMessage = getDatePickerValidationErrorMessage(dateInputValue, true)

    /* v8 ignore next */
    if (errorMessage) {
      return setDatePickerError(errorMessage)
    }

    handleTracking(dateInputValue)
    handleDispatch(dateInputValue)
  }

  const { imgObj, title } = data

  return (
    <DatePickerPage
      buttonText="Next"
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isFocused
      max={constructDate(new Date(), false)}
      newErrorMessage={datePickerError}
      purchasedDate={date}
      ref={FlightDateInput}
      renderError={datePickerError !== ''}
      testId="flight-date-page"
      title={title}
    />
  )
}
